import { captureException } from "@/observability/sentry";

export function safeLocalStorage() {
  try {
    // If window object is not available we returned null
    if (!window) {
      return null;
    }

    try {
      window.localStorage;
    } catch {
      // If users security policy prevents localStorage access we return null
      return null;
    }

    /**
     * No need to track errors on the safe calls
     */
    return {
      getItem: (key: string) => {
        if (typeof key !== "string") return null;
        try {
          return window.localStorage.getItem(key);
        } catch {
          return null;
        }
      },
      setItem: (key: string, value: unknown) => {
        if (typeof key !== "string") return;
        const valueString =
          typeof value === "string" ? value : JSON.stringify(value);
        try {
          window.localStorage.setItem(key, valueString);
        } catch {
          return;
        }
      },
      removeItem: (key: string) => {
        try {
          window.localStorage.removeItem(key);
        } catch {
          return;
        }
      },
      clear: () => {
        try {
          window.localStorage.clear();
        } catch {
          return;
        }
      },
    };
  } catch (ex) {
    // Need to keep track of the high level errors that have to do with
    // security policies around localStorage
    captureException(ex);

    // In case of an error with localStorage we return null
    return null;
  }
}
